import SEO from "@/components/SEO";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function ThankYou() {
  return (
    <>
      <SEO title="Thank you — Tech Alpha SSL" description="Thank you — we've received your message." canonical="https://techalphassl.com/thank-you" />
      <section className="pt-24 pb-24">
        <div className="container-page max-w-2xl text-center">
          <div className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-[#1565FF]/10 text-[#1565FF] dark:bg-white/5 dark:text-[#4FC3F7]">
            <CheckCircle2 className="h-8 w-8" />
          </div>
          <h1 className="mt-6 text-3xl md:text-5xl font-semibold tracking-tighter">Thank you.</h1>
          <p className="mt-4 text-muted-foreground">We've received your message. Our team typically replies within one business hour.</p>
          <div className="mt-8">
            <Link to="/" className="btn-primary" data-testid="ty-home">Back to home</Link>
          </div>
        </div>
      </section>
    </>
  );
}
